import { render, staticRenderFns } from "./BookingActIcon.vue?vue&type=template&id=3f57edfd"
import script from "./BookingActIcon.vue?vue&type=script&lang=js"
export * from "./BookingActIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports